import { render, staticRenderFns } from "./exSummary.vue?vue&type=template&id=63a57a62&scoped=true"
import script from "./exSummary.vue?vue&type=script&lang=js"
export * from "./exSummary.vue?vue&type=script&lang=js"
import style0 from "./exSummary.vue?vue&type=style&index=0&id=63a57a62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a57a62",
  null
  
)

export default component.exports